import { render, staticRenderFns } from "./RightAlertPanel.vue?vue&type=template&id=f36968d6&scoped=true&"
import script from "./RightAlertPanel.vue?vue&type=script&lang=js&"
export * from "./RightAlertPanel.vue?vue&type=script&lang=js&"
import style0 from "./RightAlertPanel.vue?vue&type=style&index=0&id=f36968d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36968d6",
  null
  
)

export default component.exports